<template>  
    <div class="loading-overlay" v-if="isLoading">  
      <div class="loading-spinner">正在思考中... <span  class="loader"></span></div>  
    </div>  
  </template>  
  
  <script>  
  export default {  
    props: {  
      isLoading: {  
        type: Boolean,  
        required: true,  
      },  
    },  
  };  
  </script>  
  
  <style scoped>  
  .loading-overlay {  
    position: absolute;  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    background-color: rgba(128, 128, 128, 0.5);
    display: flex;  
    justify-content: center;  
    align-items: center;  
    z-index: 1000; /* 确保加载层在最上面 */  
  }  
  
  .loading-spinner {  
    font-size: 20px;  
    font-weight: bold;  
  }  
  .loader {
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
  display: inline-block; /* Ensure it displays inline with text */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  </style>  